// Registro del service worker y actualización controlada (§13): se avisa "Hay una nueva versión
// disponible" y solo se activa cuando no hay borradores sin guardar, compresión ni cargas.
import { registerSW } from 'virtual:pwa-register';
import { isBusy, setUpdateAvailable } from './store.ts';

let applyUpdate: ((reload?: boolean) => Promise<void>) | null = null;

export function startServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;
  applyUpdate = registerSW({
    immediate: true,
    onNeedRefresh() {
      setUpdateAvailable(true);
    },
    onRegisteredSW(_url, registration) {
      // Busca versiones nuevas cada hora con la app abierta.
      if (registration) setInterval(() => void registration.update().catch(() => undefined), 60 * 60 * 1000);
    },
  });
}

/** Activa la nueva versión y recarga. Devuelve false si hay trabajo en curso. */
export async function updateNow(): Promise<boolean> {
  if (isBusy() || !applyUpdate) return false;
  await applyUpdate(true);
  return true;
}
